import { render, staticRenderFns } from "./SendinvoiceMailComponent.vue?vue&type=template&id=6f72d67a&scoped=true"
import script from "./SendinvoiceMailComponent.vue?vue&type=script&lang=js"
export * from "./SendinvoiceMailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72d67a",
  null
  
)

export default component.exports